export const SecuritySection: React.FC = () => {
  const bullets = [
    "Role-based access & project-level permissions",
    "Audit trails and provenance",
    "Private deployment options",
    "Defensible answers with citations"
  ];

  return (
    <section
      id="security"
      className="security-section section-spacing bg-gradient-to-b from-gray-50 to-white relative overflow-hidden"
    >
      {/* Background construction image - Unsplash free license */}
      <div className="absolute left-0 top-0 w-1/2 h-full opacity-5 pointer-events-none hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1517089596392-fb9a9033e05b?auto=format&fit=crop&w=1000&q=80"
          alt="Construction site"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="container mx-auto grid md:grid-cols-2 gap-12 items-start relative z-10">
        <div>
          <h2 className="text-4xl font-bold text-slate-900 mb-6 leading-tight">
            Governance-first by design
          </h2>
          <p className="text-lg text-slate-700 mb-6 leading-relaxed">
            ARK is built for mission-critical programs where trust is non-negotiable, role-based access, audit trails, provenance, and deployment options to match program requirements.
          </p>
          <ul className="space-y-4">
            {bullets.map((bullet) => (
              <li key={bullet} className="flex items-start gap-3">
                <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-base text-slate-700">{bullet}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="trust-card rounded-2xl border border-slate-200 bg-white p-8 shadow-lg">
          <div className="w-16 h-16 bg-violet-100 rounded-2xl flex items-center justify-center mb-6">
            <svg className="w-8 h-8 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-slate-900 mb-4">Trust & Compliance</h3>
          <p className="text-slate-700 mb-4 text-base leading-relaxed">
            Every answer is backed by verifiable project documents, with full query
            history for audit and compliance.
          </p>
          <p className="text-slate-700 text-base leading-relaxed">
            ARK offers strict data isolation for each customer and project, ensuring
            your construction data is never mixed or exposed.
          </p>
        </div>
      </div>
    </section>
  );
};
